import { render, staticRenderFns } from "./realitySimulation.vue?vue&type=template&id=754dbccc&scoped=true&"
import script from "./realitySimulation.vue?vue&type=script&lang=js&"
export * from "./realitySimulation.vue?vue&type=script&lang=js&"
import style0 from "./realitySimulation.vue?vue&type=style&index=0&id=754dbccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754dbccc",
  null
  
)

export default component.exports